// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../dashboard/web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../dashboard/web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
    font-family: 'Montserrat', Arial, sans-serif;
    font-size: 14px;
    line-height: 24px;
    background: #fff;
    color: #3e444f;
    font-weight: 300;
    margin: 0;
    padding: 0;
    height: 100%;
}

.eevi_text {
    font-family: 'Montserrat', Arial, sans-serif;
    font-size: 14px;
    font-weight: 300;
}

button, input, optgroup, select, textarea {
    font-family: 'Montserrat', Arial, sans-serif;
}

.eevi_header_title h3,
h3 {
    font-family: 'Montserrat', Arial, sans-serif;
    line-height: 37px;
    text-transform: none;
    color: #3e444f;
    font-weight: 700;
    font-size: 2.2vh;
}

h5 {
    font-weight: 600;
}

.scale-text {
    font-size: 1.5vh;
}

.container-fluid {
    padding-right: 0;
    padding-left: 0;
}

.eevi_dropdown, .eevi_dropdown:active {
    background-color: transparent;
    border-color: transparent;
}

.eevi_dropdown_no_border {
    min-width: 12rem;
    border: 0;
}

.eevi_wide_dropdown_no_border {
    min-width: 24rem;
    border: 0;
}


.xx-small {
    font-size: xx-small;
}

.smaller {
    font-size: smaller;
}


.x-small {
    font-size: x-small;
}



.eevi_dropdown:hover, :focus {
    color: #0056b3;
    background-color: transparent;  /* bg needed? */
    border-color: transparent;
    outline: none;
}

label {
    font-family: 'Montserrat', Arial, sans-serif;
    font-size: 17px;
    margin-top: 8px;
}

#app {
    min-height: 100%;
}

.eevi_white_band {
    background-color: #fff;
    min-height: 10px;
    width: 100%;
}

.eevi_gold_band {
    background-color: #fcb813;
    min-height: 10px;
    width: 100%;
}

.eevi_thin_gold_band {
    background-color: #fcb813;
    min-height: 5px;
    width: 100%;
}

.eevi_light_yellow {
    background-color: rgba(255, 255, 200, .125);
}

.eevi_light_grey_color {
    color: #797D82;
}

.panel-eevi > .panel-heading {
    background-color: #fcb813;
    border-color: #faebcc;
    border-radius: 0 0 10px 10px;
    padding: 11px 0 12px;
}

.eevi_header {
    background: #fff;
}

.eevi_header_title {
    background: #fff;
    padding: 0;
}


.eevi_text {
    font-size: 14px;
    color: #555;
    margin-top: 8px;
}

/* cards */

.card-title {
    font-weight: bold;
}

/* buttons */

.btn-primary {
    color: #fff;
    border-color: #fcb813;
    background: #fcb813 linear-gradient(to bottom, #e29f03 0, #fcc136 100%);
}



.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .open > .dropdown-toggle.btn-primary {
    color: #fff;
    background-color: #fcb813;
    border-color: #fcb813;
}

.btn-link {
    text-decoration-line: underline;
}

.btn-primary.disabled, .btn-primary.disabled.active, .btn-primary.disabled.focus, .btn-primary.disabled:active,
.btn-primary.disabled:focus, .btn-primary.disabled:hover, .btn-primary[disabled], .btn-primary[disabled].active,
.btn-primary[disabled].focus, .btn-primary[disabled]:active, .btn-primary[disabled]:focus, .btn-primary[disabled]:hover,
fieldset[disabled] .btn-primary, fieldset[disabled] .btn-primary.active, fieldset[disabled] .btn-primary.focus,
fieldset[disabled] .btn-primary:active, fieldset[disabled] .btn-primary:focus, fieldset[disabled] .btn-primary:hover,
.form-control:disabled, .form-control[readonly], .eevi_edit_button.disabled, .eevi_add_button.disabled, .eevi_connectivity_button.disabled {
    background: #f4f5f7 none;
    border-color: #ced4da;
    color: #c7c9cc;
}

.form-control:disabled, .form-control[readonly] {
    background: #f4f5f7 none;
    border-color: #ced4da;
    color: #c7c9cc;
    opacity: 0.65;
}

.btn-outline-secondary {
    border-color: rgba(0, 0, 0, 0.125);
}

.eevi_edit_text {
    border-color: #efcf71;
}

/* vertical align checkboxes and their labels */
.eevi_check_box {
    border-color: #efcf71;
    position: relative;
    vertical-align: middle;
    bottom: 3px;
}

.eevi_edit_button, .eevi_add_button {
    width: 80px;
    background-color: #f7f8f9;
    border-color: #e0eaed;
}

.eevi_edit_button_dialog {
    width: 80px;
    background-color: #f7f8f9;
    border-color: #e0eaed;
    margin: 1.0em;
    text-align: center
}

.eevi_add_button {
    margin-bottom: 1px;
}

.eevi_edit_button:focus, .eevi_add_button:focus {
    border-color: transparent;
}

.eevi_connectivity_button{
    width: 90px;
    background-color: #f7f8f9;
    border-color: #e0eaed;
}

.eevi_top_add_button {
    width: 108px;
    margin-bottom: 1px;
    background-color: #f7f8f9;
    border-color: #e0eaed;
}


/* fix problem with z-index when dropdown overlaps button */
.input-group-btn:last-child > .btn, .input-group-btn:last-child > .btn-group {
    z-index: unset;
}

.table-hover tbody tr:hover td, .table-hover tbody tr:hover th {
    background-color: #feefcd;
}

.table-bordered > thead > tr > th {
    border-top: solid 1px transparent;
    border-right: solid 1px transparent;
    border-left: solid 1px transparent;
    border-bottom-width: 2px;
}

.table > thead:first-child > tr:first-child > th {
    border-top: solid 1px transparent;
}

.navbar-default, .navbar-collapse, .navbar-default .navbar-form {
    font-size: 17px;
    border-color: #fff;
    background: #fff none;
    box-shadow: none;
    padding: 33px 0 0;
}

.nav-item:hover {
    border-bottom: 1px solid #fcb813;
    text-decoration: none;
    color: black;
}

.nav-item a {
    color: #3e444f;
    font-weight: 300;
    padding-right: 0.5em;
}

.nav-item a:hover {
    text-decoration: none;
    font-weight: normal;
}

.nav-item > div > button {
    color: #3e444f;
    font-weight: 300;
    padding-top: 0;
    padding-left: 0;
    padding-right: 0.5em;
    border: none;
    text-decoration: none;
    background-color: transparent;
    font-size: 17px;
    bottom: 1px;
}


.nav-item > div > button:hover, :active, :focus,
.eevi_dropdown > button:active,
.eevi_dropdown > .btn:active,
.eevi_dropdown > .btn-secondary:not(:disabled):active,
.eevi_dropdown > .btn-secondary:not(:disabled):active:focus,
.eevi_dropdown > .btn:focus, .eevi_dropdown > .btn-secondary:focus {
    color: #3e444f;
    text-decoration: none;
    font-weight: normal;
    border: none;
    background-color: transparent;  /* bg needed? */
    box-shadow: none;
}

.dropdown-item.active, .dropdown-item:active {
    color: #3e444f;
    text-decoration: none;
    background-color: #feeed0;
    border: none;
    outline: none;
}

.nav-link {
    color: black;
}

.inline-block {
    display: inline-block !important;
}

.navbar-toggler {
    padding: 0;
}

.progress-bar {
    float: none;
    width: 0;
    height: 100%;
    font-size: 12px;
    line-height: 20px;
    color: #fff;
    text-align: center;
    background: #fcb813 linear-gradient(to bottom, #e29f03 0, #fcc136 100%);
    -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .15);
    box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .15);
    -webkit-transition: width .6s ease;
    -o-transition: width .6s ease;
    transition: width .6s ease;
}


.modal-content {
    padding: 1.25rem;
    border-left: .25rem solid #fcb813;
}

.modal-content#remove-device {
    padding: 1.25rem;
    border-left: .25rem solid #fff;  /* Without this, the #fcb813 left border appears. */
    background: #fff;
}

/*
      react-select / multiselect
*/
div.css-1aya2g8 {
    font-size: 14px;
    height: 34px;
    min-height: 34px;
    line-height: 1.42857143;
    color: #555;
    background: #fff none;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}

.input-group .css-1aya2g8:first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}


/* Generic style to use with div or td to preserve carriage returns */
.keep-lines {
    white-space: pre-wrap;
}

.small-font {
    font-size: 10px;
}

.bold {
    font-weight: bold;
}

.icon-error {
    font-size: 17px;
    font-weight: bold;
    color: #e64943;
}

.icon-tick {
    font-size: 17px;
    font-weight: bold;
    color: #FDB913;
}

.icon-error:before {
    content: 'x';
}

.icon-tick:before {
    content: '\\002713';
}

.running {
    font-style: italic;
}

.center {
    text-align: center;
}

.right {
    text-align: right;
}

/* fix problem with overlapping dropdowns */
.form-control {
    z-index: unset;
}

.input-group .form-control {
    z-index: unset;
}

/* get rid of the blue glow on input focus */
.form-control:focus {
    border-color: #feefcd;
    box-shadow: #feefcd 0px 0px 0px 1px;
}

.eevi_small_loader {
    margin: auto;
    line-height: 14px;
    border: 4px dotted #fcb813;
    border-radius: 5%;
    width: 14px;
    height: 14px;
    -webkit-animation: spin 3s linear infinite; /* Safari */
    animation: spin 3s linear infinite;
}

.eevi_small_loader, .eevi_small_loader_poll {
    margin: auto;
    line-height: 14px;
    border: 4px dotted #fcb813;
    border-radius: 5%;
    width: 14px;
    height: 14px;
    -webkit-animation: spin 3s linear infinite; /* Safari */
    animation: spin 3s linear infinite;
}


.eevi_loader {
    margin: auto;
    line-height: 14px;
    border: 8px dotted #fcb813;
    border-radius: 5%;
    width: 24px;
    height: 24px;
    -webkit-animation: spin 3s linear infinite; /* Safari */
    animation: spin 3s linear infinite;
}


.eevi_online_status {
    margin: auto;
    width: 14px;
    height: 14px;
}


/* Safari */
@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

/* Is this a bootstrap bug? */
.table-borderless {
    border-top-style: hidden;
}

.table-borderless td {
    border: 0;
    border-style: hidden;
}

.shadow {
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    transition: box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.invalid-feedback {
    display: block;
    margin-top: 0;
    margin-bottom: 0.2rem;
}

.valid-feedback {
    display: block;
    margin-top: 0;
    margin-bottom: 0.2rem;
}

.eevi_callout {
    padding: 1.25rem;
    margin-bottom: 1.25rem;
    border: 1px solid #eee;
    border-left: .25rem solid #fcb813;
    border-radius: .25rem;
}

/*Collapse toggle button extension to bootstrap*/
.eevi_collapse_open, .eevi_collapse_open:hover:focus {
    width: 100%;
    border-color: #feeed0;
    background: #feeed0 linear-gradient(to bottom, #feefcd 0, #feefdf 100%);
    font-weight: bolder;
    border-style: none;
}

.eevi_collapse_closed, .eevi_collapse_closed:hover:focus {
    width: 100%;
    color: grey;
    border-color: #f2f2f2;
    background: #f2f2f2;
    font-weight: lighter;
    border-style: none;
}

button, select {
    /* text-transform: none; */
}

.eevi_collapse_open:focus, .eevi_collapse_closed:focus {
    outline: 0;
}


.eevi_collapse_open:hover, .eevi_collapse_closed:hover {
    outline: 0;
    background: #feeed0 linear-gradient(to bottom, #f2f2f2 0, #feefdf 100%);
    cursor: pointer;
}

/*3rd part editor for yaml. etc*/
.ace-eclipse .ace_gutter {
    background: #feeed0 linear-gradient(to bottom, #feefcd 0, #feefdf 100%);
}

.quicksight-embedding-iframe {
    border-color: transparent;
}

.eevi-content-container {
    background: #FFDD7F; /*eevi lemon */
}

.eevi_no_focus {
}

.eevi_no_focus:focus {
    outline: none;
    box-shadow: none;
}

.eevi_diff_insert, .eevi_diff_delete, .eevi_diff_modify, .eevi_diff_unchanged {
    width: 100%;
    white-space: pre;
    font-family: "monospace" ;
}

.eevi_diff_insert {
    background-color: honeydew;
}
.eevi_diff_delete {
    background-color: darksalmon;
}

.eevi_diff_modify {
    background-color: lightyellow;
}

.eevi_diff_unchanged {
    background-color: #fffffb;
}


.eevi_village_names {
  font-size: 10px;
  padding-left: 0;
}

.eevi_village_names p{
    margin-bottom: 0rem;
}`, "",{"version":3,"sources":["webpack://./../../common/web_common/styles/eevi.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;IAC5C,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;;IAEI,4CAA4C;IAC5C,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;AACtB;;;;AAIA;IACI,cAAc;IACd,6BAA6B,GAAG,eAAe;IAC/C,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,4CAA4C;IAC5C,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;;AAGA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA,UAAU;;AAEV;IACI,iBAAiB;AACrB;;AAEA,YAAY;;AAEZ;IACI,WAAW;IACX,qBAAqB;IACrB,uEAAuE;AAC3E;;;;AAIA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;;;;;IAMI,wBAAwB;IACxB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA,+CAA+C;AAC/C;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;AACzB;;;AAGA,2DAA2D;AAC3D;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;IACjC,mCAAmC;IACnC,kCAAkC;IAClC,wBAAwB;AAC5B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,qBAAqB;IACrB,6BAA6B;IAC7B,eAAe;IACf,WAAW;AACf;;;AAGA;;;;;;IAMI,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,6BAA6B,GAAG,eAAe;IAC/C,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,uEAAuE;IACvE,qDAAqD;IACrD,6CAA6C;IAC7C,kCAAkC;IAClC,6BAA6B;IAC7B,0BAA0B;AAC9B;;;AAGA;IACI,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,8BAA8B,GAAG,mDAAmD;IACpF,gBAAgB;AACpB;;AAEA;;CAEC;AACD;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,+CAA+C;IAC/C,sEAAsE;AAC1E;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;;AAGA,qEAAqE;AACrE;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,2CAA2C;AAC3C;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,4CAA4C;AAC5C;IACI,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;IAC1B,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,0CAA0C,EAAE,WAAW;IACvD,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;IAC1B,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,0CAA0C,EAAE,WAAW;IACvD,kCAAkC;AACtC;;;AAGA;IACI,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;IAC1B,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,0CAA0C,EAAE,WAAW;IACvD,kCAAkC;AACtC;;;AAGA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;;AAGA,WAAW;AACX;IACI;QACI,+BAA+B;IACnC;IACA;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,6BAA6B;AAC7B;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,0HAA0H;IAC1H,yDAAyD;AAC7D;;AAEA;IACI,cAAc;IACd,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,iCAAiC;IACjC,qBAAqB;AACzB;;AAEA,gDAAgD;AAChD;IACI,WAAW;IACX,qBAAqB;IACrB,uEAAuE;IACvE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,UAAU;IACV,uEAAuE;IACvE,eAAe;AACnB;;AAEA,gCAAgC;AAChC;IACI,uEAAuE;AAC3E;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB,EAAE,cAAc;AACvC;;AAEA;AACA;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["html, body {\n    font-family: 'Montserrat', Arial, sans-serif;\n    font-size: 14px;\n    line-height: 24px;\n    background: #fff;\n    color: #3e444f;\n    font-weight: 300;\n    margin: 0;\n    padding: 0;\n    height: 100%;\n}\n\n.eevi_text {\n    font-family: 'Montserrat', Arial, sans-serif;\n    font-size: 14px;\n    font-weight: 300;\n}\n\nbutton, input, optgroup, select, textarea {\n    font-family: 'Montserrat', Arial, sans-serif;\n}\n\n.eevi_header_title h3,\nh3 {\n    font-family: 'Montserrat', Arial, sans-serif;\n    line-height: 37px;\n    text-transform: none;\n    color: #3e444f;\n    font-weight: 700;\n    font-size: 2.2vh;\n}\n\nh5 {\n    font-weight: 600;\n}\n\n.scale-text {\n    font-size: 1.5vh;\n}\n\n.container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n}\n\n.eevi_dropdown, .eevi_dropdown:active {\n    background-color: transparent;\n    border-color: transparent;\n}\n\n.eevi_dropdown_no_border {\n    min-width: 12rem;\n    border: 0;\n}\n\n.eevi_wide_dropdown_no_border {\n    min-width: 24rem;\n    border: 0;\n}\n\n\n.xx-small {\n    font-size: xx-small;\n}\n\n.smaller {\n    font-size: smaller;\n}\n\n\n.x-small {\n    font-size: x-small;\n}\n\n\n\n.eevi_dropdown:hover, :focus {\n    color: #0056b3;\n    background-color: transparent;  /* bg needed? */\n    border-color: transparent;\n    outline: none;\n}\n\nlabel {\n    font-family: 'Montserrat', Arial, sans-serif;\n    font-size: 17px;\n    margin-top: 8px;\n}\n\n#app {\n    min-height: 100%;\n}\n\n.eevi_white_band {\n    background-color: #fff;\n    min-height: 10px;\n    width: 100%;\n}\n\n.eevi_gold_band {\n    background-color: #fcb813;\n    min-height: 10px;\n    width: 100%;\n}\n\n.eevi_thin_gold_band {\n    background-color: #fcb813;\n    min-height: 5px;\n    width: 100%;\n}\n\n.eevi_light_yellow {\n    background-color: rgba(255, 255, 200, .125);\n}\n\n.eevi_light_grey_color {\n    color: #797D82;\n}\n\n.panel-eevi > .panel-heading {\n    background-color: #fcb813;\n    border-color: #faebcc;\n    border-radius: 0 0 10px 10px;\n    padding: 11px 0 12px;\n}\n\n.eevi_header {\n    background: #fff;\n}\n\n.eevi_header_title {\n    background: #fff;\n    padding: 0;\n}\n\n\n.eevi_text {\n    font-size: 14px;\n    color: #555;\n    margin-top: 8px;\n}\n\n/* cards */\n\n.card-title {\n    font-weight: bold;\n}\n\n/* buttons */\n\n.btn-primary {\n    color: #fff;\n    border-color: #fcb813;\n    background: #fcb813 linear-gradient(to bottom, #e29f03 0, #fcc136 100%);\n}\n\n\n\n.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .open > .dropdown-toggle.btn-primary {\n    color: #fff;\n    background-color: #fcb813;\n    border-color: #fcb813;\n}\n\n.btn-link {\n    text-decoration-line: underline;\n}\n\n.btn-primary.disabled, .btn-primary.disabled.active, .btn-primary.disabled.focus, .btn-primary.disabled:active,\n.btn-primary.disabled:focus, .btn-primary.disabled:hover, .btn-primary[disabled], .btn-primary[disabled].active,\n.btn-primary[disabled].focus, .btn-primary[disabled]:active, .btn-primary[disabled]:focus, .btn-primary[disabled]:hover,\nfieldset[disabled] .btn-primary, fieldset[disabled] .btn-primary.active, fieldset[disabled] .btn-primary.focus,\nfieldset[disabled] .btn-primary:active, fieldset[disabled] .btn-primary:focus, fieldset[disabled] .btn-primary:hover,\n.form-control:disabled, .form-control[readonly], .eevi_edit_button.disabled, .eevi_add_button.disabled, .eevi_connectivity_button.disabled {\n    background: #f4f5f7 none;\n    border-color: #ced4da;\n    color: #c7c9cc;\n}\n\n.form-control:disabled, .form-control[readonly] {\n    background: #f4f5f7 none;\n    border-color: #ced4da;\n    color: #c7c9cc;\n    opacity: 0.65;\n}\n\n.btn-outline-secondary {\n    border-color: rgba(0, 0, 0, 0.125);\n}\n\n.eevi_edit_text {\n    border-color: #efcf71;\n}\n\n/* vertical align checkboxes and their labels */\n.eevi_check_box {\n    border-color: #efcf71;\n    position: relative;\n    vertical-align: middle;\n    bottom: 3px;\n}\n\n.eevi_edit_button, .eevi_add_button {\n    width: 80px;\n    background-color: #f7f8f9;\n    border-color: #e0eaed;\n}\n\n.eevi_edit_button_dialog {\n    width: 80px;\n    background-color: #f7f8f9;\n    border-color: #e0eaed;\n    margin: 1.0em;\n    text-align: center\n}\n\n.eevi_add_button {\n    margin-bottom: 1px;\n}\n\n.eevi_edit_button:focus, .eevi_add_button:focus {\n    border-color: transparent;\n}\n\n.eevi_connectivity_button{\n    width: 90px;\n    background-color: #f7f8f9;\n    border-color: #e0eaed;\n}\n\n.eevi_top_add_button {\n    width: 108px;\n    margin-bottom: 1px;\n    background-color: #f7f8f9;\n    border-color: #e0eaed;\n}\n\n\n/* fix problem with z-index when dropdown overlaps button */\n.input-group-btn:last-child > .btn, .input-group-btn:last-child > .btn-group {\n    z-index: unset;\n}\n\n.table-hover tbody tr:hover td, .table-hover tbody tr:hover th {\n    background-color: #feefcd;\n}\n\n.table-bordered > thead > tr > th {\n    border-top: solid 1px transparent;\n    border-right: solid 1px transparent;\n    border-left: solid 1px transparent;\n    border-bottom-width: 2px;\n}\n\n.table > thead:first-child > tr:first-child > th {\n    border-top: solid 1px transparent;\n}\n\n.navbar-default, .navbar-collapse, .navbar-default .navbar-form {\n    font-size: 17px;\n    border-color: #fff;\n    background: #fff none;\n    box-shadow: none;\n    padding: 33px 0 0;\n}\n\n.nav-item:hover {\n    border-bottom: 1px solid #fcb813;\n    text-decoration: none;\n    color: black;\n}\n\n.nav-item a {\n    color: #3e444f;\n    font-weight: 300;\n    padding-right: 0.5em;\n}\n\n.nav-item a:hover {\n    text-decoration: none;\n    font-weight: normal;\n}\n\n.nav-item > div > button {\n    color: #3e444f;\n    font-weight: 300;\n    padding-top: 0;\n    padding-left: 0;\n    padding-right: 0.5em;\n    border: none;\n    text-decoration: none;\n    background-color: transparent;\n    font-size: 17px;\n    bottom: 1px;\n}\n\n\n.nav-item > div > button:hover, :active, :focus,\n.eevi_dropdown > button:active,\n.eevi_dropdown > .btn:active,\n.eevi_dropdown > .btn-secondary:not(:disabled):active,\n.eevi_dropdown > .btn-secondary:not(:disabled):active:focus,\n.eevi_dropdown > .btn:focus, .eevi_dropdown > .btn-secondary:focus {\n    color: #3e444f;\n    text-decoration: none;\n    font-weight: normal;\n    border: none;\n    background-color: transparent;  /* bg needed? */\n    box-shadow: none;\n}\n\n.dropdown-item.active, .dropdown-item:active {\n    color: #3e444f;\n    text-decoration: none;\n    background-color: #feeed0;\n    border: none;\n    outline: none;\n}\n\n.nav-link {\n    color: black;\n}\n\n.inline-block {\n    display: inline-block !important;\n}\n\n.navbar-toggler {\n    padding: 0;\n}\n\n.progress-bar {\n    float: none;\n    width: 0;\n    height: 100%;\n    font-size: 12px;\n    line-height: 20px;\n    color: #fff;\n    text-align: center;\n    background: #fcb813 linear-gradient(to bottom, #e29f03 0, #fcc136 100%);\n    -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .15);\n    box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .15);\n    -webkit-transition: width .6s ease;\n    -o-transition: width .6s ease;\n    transition: width .6s ease;\n}\n\n\n.modal-content {\n    padding: 1.25rem;\n    border-left: .25rem solid #fcb813;\n}\n\n.modal-content#remove-device {\n    padding: 1.25rem;\n    border-left: .25rem solid #fff;  /* Without this, the #fcb813 left border appears. */\n    background: #fff;\n}\n\n/*\n      react-select / multiselect\n*/\ndiv.css-1aya2g8 {\n    font-size: 14px;\n    height: 34px;\n    min-height: 34px;\n    line-height: 1.42857143;\n    color: #555;\n    background: #fff none;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n}\n\n.input-group .css-1aya2g8:first-child {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n\n/* Generic style to use with div or td to preserve carriage returns */\n.keep-lines {\n    white-space: pre-wrap;\n}\n\n.small-font {\n    font-size: 10px;\n}\n\n.bold {\n    font-weight: bold;\n}\n\n.icon-error {\n    font-size: 17px;\n    font-weight: bold;\n    color: #e64943;\n}\n\n.icon-tick {\n    font-size: 17px;\n    font-weight: bold;\n    color: #FDB913;\n}\n\n.icon-error:before {\n    content: 'x';\n}\n\n.icon-tick:before {\n    content: '\\002713';\n}\n\n.running {\n    font-style: italic;\n}\n\n.center {\n    text-align: center;\n}\n\n.right {\n    text-align: right;\n}\n\n/* fix problem with overlapping dropdowns */\n.form-control {\n    z-index: unset;\n}\n\n.input-group .form-control {\n    z-index: unset;\n}\n\n/* get rid of the blue glow on input focus */\n.form-control:focus {\n    border-color: #feefcd;\n    box-shadow: #feefcd 0px 0px 0px 1px;\n}\n\n.eevi_small_loader {\n    margin: auto;\n    line-height: 14px;\n    border: 4px dotted #fcb813;\n    border-radius: 5%;\n    width: 14px;\n    height: 14px;\n    -webkit-animation: spin 3s linear infinite; /* Safari */\n    animation: spin 3s linear infinite;\n}\n\n.eevi_small_loader, .eevi_small_loader_poll {\n    margin: auto;\n    line-height: 14px;\n    border: 4px dotted #fcb813;\n    border-radius: 5%;\n    width: 14px;\n    height: 14px;\n    -webkit-animation: spin 3s linear infinite; /* Safari */\n    animation: spin 3s linear infinite;\n}\n\n\n.eevi_loader {\n    margin: auto;\n    line-height: 14px;\n    border: 8px dotted #fcb813;\n    border-radius: 5%;\n    width: 24px;\n    height: 24px;\n    -webkit-animation: spin 3s linear infinite; /* Safari */\n    animation: spin 3s linear infinite;\n}\n\n\n.eevi_online_status {\n    margin: auto;\n    width: 14px;\n    height: 14px;\n}\n\n\n/* Safari */\n@-webkit-keyframes spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n    }\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n/* Is this a bootstrap bug? */\n.table-borderless {\n    border-top-style: hidden;\n}\n\n.table-borderless td {\n    border: 0;\n    border-style: hidden;\n}\n\n.shadow {\n    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);\n    transition: box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.invalid-feedback {\n    display: block;\n    margin-top: 0;\n    margin-bottom: 0.2rem;\n}\n\n.valid-feedback {\n    display: block;\n    margin-top: 0;\n    margin-bottom: 0.2rem;\n}\n\n.eevi_callout {\n    padding: 1.25rem;\n    margin-bottom: 1.25rem;\n    border: 1px solid #eee;\n    border-left: .25rem solid #fcb813;\n    border-radius: .25rem;\n}\n\n/*Collapse toggle button extension to bootstrap*/\n.eevi_collapse_open, .eevi_collapse_open:hover:focus {\n    width: 100%;\n    border-color: #feeed0;\n    background: #feeed0 linear-gradient(to bottom, #feefcd 0, #feefdf 100%);\n    font-weight: bolder;\n    border-style: none;\n}\n\n.eevi_collapse_closed, .eevi_collapse_closed:hover:focus {\n    width: 100%;\n    color: grey;\n    border-color: #f2f2f2;\n    background: #f2f2f2;\n    font-weight: lighter;\n    border-style: none;\n}\n\nbutton, select {\n    /* text-transform: none; */\n}\n\n.eevi_collapse_open:focus, .eevi_collapse_closed:focus {\n    outline: 0;\n}\n\n\n.eevi_collapse_open:hover, .eevi_collapse_closed:hover {\n    outline: 0;\n    background: #feeed0 linear-gradient(to bottom, #f2f2f2 0, #feefdf 100%);\n    cursor: pointer;\n}\n\n/*3rd part editor for yaml. etc*/\n.ace-eclipse .ace_gutter {\n    background: #feeed0 linear-gradient(to bottom, #feefcd 0, #feefdf 100%);\n}\n\n.quicksight-embedding-iframe {\n    border-color: transparent;\n}\n\n.eevi-content-container {\n    background: #FFDD7F; /*eevi lemon */\n}\n\n.eevi_no_focus {\n}\n\n.eevi_no_focus:focus {\n    outline: none;\n    box-shadow: none;\n}\n\n.eevi_diff_insert, .eevi_diff_delete, .eevi_diff_modify, .eevi_diff_unchanged {\n    width: 100%;\n    white-space: pre;\n    font-family: \"monospace\" ;\n}\n\n.eevi_diff_insert {\n    background-color: honeydew;\n}\n.eevi_diff_delete {\n    background-color: darksalmon;\n}\n\n.eevi_diff_modify {\n    background-color: lightyellow;\n}\n\n.eevi_diff_unchanged {\n    background-color: #fffffb;\n}\n\n\n.eevi_village_names {\n  font-size: 10px;\n  padding-left: 0;\n}\n\n.eevi_village_names p{\n    margin-bottom: 0rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
